// extracted by mini-css-extract-plugin
module.exports = {"SkeletonBodyTextLine":"SkeletonBodyText_SkeletonBodyTextLine_367ur","SkeletonShimmerAnimation":"SkeletonBodyText_SkeletonShimmerAnimation_1mC-Z"};